import React, { Component } from "react";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";

import * as styles from "./ListHeader.scss";

export interface IListHeaderProps extends ITestableComponentProps {
    title: string;
    children?: React.ReactNode;
}

export class ListHeader extends Component<IListHeaderProps> {
    public render() {
        const { title, children } = this.props;
        return (
            <div
                className={styles["list-header"]}
                data-testid={this.props["data-testid"]}
            >
                <div className={styles.heading}>{title}</div>
                <div className={styles.children}>{children}</div>
            </div>
        );
    }
}
